


































































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'ShippingAreaCard'

  vue:
    props: ['item', 'options']

    components: {
      LoadingIndicator,
    }

    data: ->
      mapOptions:
        draggable: true
        zoomControl: false
        mapTypeControl: false
        mapTypeId: 'satellite'
        tilt: 0
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true

    computed:
      editable: ->
        return @options.editable if @options?.editable?
        true

      location: ->
        @$options.filters.formatLocation @item

      country: ->
        return '' unless @item.country
        return 'US' if @item.country.toLowerCase() in ['us', 'united states']
        @item.country.slice(0, 2).toUpperCase()

      weekdays: -> ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

      zoom: -> 18
      lat: -> @item.geo_coordinates?[1]
      lng: -> @item.geo_coordinates?[0]

    methods:
      hiNavToDetails: ->
        @$router.push { name: 'ShippingAreaShowPage', params: { shippingAreaId: @item.id } }

export default VueOptions.vue settings
